<!--投票 Vote-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">投票</div>

    <div class="title-view" :style="{ marginRight: '' }">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <b v-if="isCountMust">
            {{ `(必须选${maxCount}项)` }}
          </b>
          <b v-else-if="isCountSwitch">
            {{ `(最多选${maxCount}项，最少${minCount}项)` }}
          </b>
          <b v-else>
            {{ `(最多选${maxCount}项)` }}
          </b>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>

    <div class="select-view">
      <p style="font-size: 28rpx; color: #2b2f36; word-break: break-all">
        {{ value }}
      </p>
    </div>

    <div v-for="(item, index) in list" :key="index">
      <div
        class="choose-css choose-css-new"
        :class="{ active: item.isChoose }"
        style="
          border: 1px solid rgba(237, 237, 237, 0.5);
          background: rgba(247, 247, 247, 1);
        "
        @click="handleChoose(item, index)"
      >
        <div class="choose-css-text">
          <p
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(43, 47, 54, 1);
            "
          >
            {{ item.text }}
          </p>

          <p
            v-if="item.percentage !== undefined"
            style="color: #666; margin-top: 4px"
          >
            {{ item.percentage }}%
          </p>
        </div>

        <!-- 图片 -->
        <div class="question-images">
          <div
            class="question-images-box"
            @click.stop="showBigImage(imgItem, item)"
            v-for="(imgItem, imgIndex) in item.img_path"
            :key="imgIndex"
            style="margin-top: 10px; position: relative"
          >
            <img :src="imgItem" mode="aspectFill" class="thumbnail-image" />
            <div class="fangda-box">查看图片</div>
          </div>
        </div>
      </div>

      <div v-if="item.is_fill && item.isChoose" class="option-item-bottom">
        <div class="option-item-bottom-input">
          <input
            placeholder-class="input-placeholder"
            type="text"
            placeholder="编辑提示词"
            v-model="item.fill_prompt"
            @blur="handleBlur(item, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      list: [],
      images: [],
      value: "",
	  isCountMust: null,
	  maxCount: null,
	  minCount: null,
	  isCountSwitch: null,
    };
  },

  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;

        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.list = JSON.parse(newVal.data.chooseList).list;
		this.isCountMust = JSON.parse(newVal.data.chooseList).isCountMust;
		this.maxCount = JSON.parse(newVal.data.chooseList).maxCount;
		this.minCount = JSON.parse(newVal.data.chooseList).minCount;
		this.isCountSwitch = JSON.parse(newVal.data.chooseList).isCountSwitch;
        this.value = newVal.data.chooseList.value;

        if (
          newVal.answer &&
          newVal.answer.answer &&
          newVal.answer.answer.length > 0
        ) {
          const answerArr = newVal.answer.answer;

          // this.list.forEach((i) => {
          //   i.isChoose = false;
          //   i.percentage = undefined;
          // });

          // answerArr.forEach((ans, i) => {
          //   if (ans.select === 1) {
          //     this.list[i].isChoose = true;
          //   }

          //   this.list[i].percentage = ans.percentage;
          // });
		  this.list.forEach((item) => {
		    item.isChoose = false;
		    item.percentage = undefined;
		  });
		  
		  answerArr.forEach((ans) => {
		    const target = this.list.find(item => item.id === ans.id);
		    
		      if (target) {
		        target.isChoose = true;
		      }
		  });
        } else {
          this.list.forEach((i) => {
            i.isChoose = false;
            i.percentage = undefined;
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.active {
  border-color: #4a73f8 !important;
  background: #e8efff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewVote.vue